import React, { useContext } from 'react';
import { getAssetUrl } from '../../helpers/get-asset-url';
import UskLabelLargeImageCommon from '../../img/common/usk/usk-label-large.png';
import UskLabelLargeImageFoe from '../../img/foe/usk/usk-label-large.png';
import UskLabelLargeImageVillage from '../../img/village/usk/usk-label-large.png';
import UskLabelLargeImageGrepo from '../../img/grepo/usk/usk-label-large.png';
import UskLabelLargeImageMobilecity from '../../img/mobilecity/usk/usk-label-large.png';
import styles from '../../css/components/common/uskLabel.css';
import LazyImage from './LazyImage';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';

// Intrinsic dimensions are kept next to each asset so the browser can reserve
// the correct box before the lazily loaded image arrives (avoids layout shift).
const uskImages = {
	foe: { src: UskLabelLargeImageFoe, width: 801, height: 297 },
	common: { src: UskLabelLargeImageCommon, width: 758, height: 297 },
	village: { src: UskLabelLargeImageVillage, width: 758, height: 297 },
	grepo: { src: UskLabelLargeImageGrepo, width: 758, height: 297 },
	mobilecity: { src: UskLabelLargeImageMobilecity, width: 758, height: 297 }
};

function UskSection() {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const gameId = onelpsParams.gameId;
	const uskImage = uskImages[gameId] || uskImages.common;

	return (
		<section
			className={`${styles.uskSection} ${styles[gameId]}`}
			data-testid="usk-section"
		>
			<LazyImage
				src={getAssetUrl() + uskImage.src}
				width={uskImage.width}
				height={uskImage.height}
				className={styles.uskImage}
			/>
		</section>
	);
}

export default UskSection;
